import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { BookCallLink } from "@/components/BookCall";

export const CTASection = ({ headline, body, testid = "cta" }) => (
  <section className="relative overflow-hidden border-t border-white/10" data-testid={`${testid}-section`}>
    <div
      className="pointer-events-none absolute inset-0"
      style={{
        background:
          "radial-gradient(ellipse 60% 50% at 20% 100%, rgba(43,217,199,0.10), transparent 70%)",
      }}
    />
    <div className="relative mx-auto max-w-7xl px-6 py-24 md:px-10 md:py-32">
      <Reveal>
        <p className="overline-label mb-6">Next Step</p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="max-w-3xl font-serif text-3xl leading-tight tracking-tight text-white sm:text-4xl md:text-5xl">
          {headline}
        </h2>
      </Reveal>
      {body && (
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-xl font-sans text-base leading-relaxed text-white/60 md:text-lg">
            {body}
          </p>
        </Reveal>
      )}
      <Reveal delay={0.3}>
        <BookCallLink testid={`${testid}-book-call`} className="btn-primary mt-10">
          Book a Call
          <ArrowUpRight className="h-4 w-4" />
        </BookCallLink>
      </Reveal>
    </div>
  </section>
);
